/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import SimpleTag from './simpleTag';

/**
 * Subscript tags
 * {sub}Text to show as subscript{/sub}
 */
export default new SimpleTag(
    'sub',
    (key, contents) => {
        return <sub key={key}>{contents}</sub>;
    },
    (contents) => contents
);
